import { Popover } from "@material-ui/core";
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { downloadSoundFile } from "..";
import { toAbsoluteUrl } from "../../../../../../../Utils/_helpers";
import ConfigurationToastMessage from "../../Util/ConfigurationToastMessage";
import EditUploadedSound from "../UploadSound/EditUploadSound";
import SoundsDialog from "../Utils/Popup/SoundsDialog";
import DeleteSoundPopupContent from "./DeleteSoundPopupContent";

const SoundActionsPopover = (props) => {
  const {
    open = false,
    anchorEl = "",
    handleClosePopover = () => {},
    sound,
  } = {
    ...props,
  };
  const id = open ? "actions-popover" : undefined;

  const selectedManageSoundTab = useSelector(
    (state) => state.soundsSlice.activeSoundTab
  );

  const [toastInfo, setToastInfo] = useState({
    open: false,
    severity: "info",
    snackbarMessage: "",
  });
  const [isEditUploadSoundOpen, setIsEditUploadSoundOpen] = useState(false);
  const [openDeletePopup, setOpenDeletePopup] = useState(false);

  const handleEditSound = () => {
    setIsEditUploadSoundOpen(true);
    handleClosePopover();
  };

  const handleCloseEditTTS = () => {
    setIsEditUploadSoundOpen(false);
  };

  const handleCloseDeletePopup = (value) => {
    handleClosePopover();
    setOpenDeletePopup(value);
  };

  const downloadSound = () => {
    if (sound) {
      downloadSoundFile(sound);
    }
    handleClosePopover();
  };

  const setToastValue = (open, msg, status) => {
    setToastInfo((prevState) => ({
      ...prevState,
      open: open,
      snackbarMessage: msg,
      severity: status,
    }));
  };

  const handleCloseSnackbar = (val) => {
    setToastInfo((prevState) => ({
      ...prevState,
      open: false,
    }));
  };

  return (
    <>
      <EditUploadedSound
        sound={sound}
        openUploadSoundEditDialog={isEditUploadSoundOpen}
        handleCloseEditUploadSound={handleCloseEditTTS}
      />

      <ConfigurationToastMessage
        severity={toastInfo.severity}
        snackbarMessage={toastInfo.snackbarMessage}
        open={toastInfo.open}
        handleCloseSnackbar={handleCloseSnackbar}
      />

      {openDeletePopup && (
        <SoundsDialog
          open={openDeletePopup}
          handleClose={() => {
            handleCloseDeletePopup(false);
          }}
          maxWidth="lg"
          title=""
        >
          <DeleteSoundPopupContent
            sound={sound}
            handleCloseDeletePopup={handleCloseDeletePopup}
            setToastValue={setToastValue}
          />
        </SoundsDialog>
      )}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        PaperProps={{
          style: {
            backgroundColor: "white",
            width: "190px",
            whiteSpace: "pre",
            padding: "10px 12px 10px 12px",
            borderRadius: "4px",
            boxShadow: "0 2px 8px 0 rgba(0, 0, 0, 0.13)",
            border: "solid 1px #f3f3f3",
            overflow: "hidden",
          },
        }}
      >
        <div>
          <div className="quick-actions-title m-3 mb-4">
            <span>
              <FormattedMessage
                id="quick-actions"
                defaultMessage="Quick Actions"
              />
            </span>
          </div>

          {selectedManageSoundTab === 0 && (
            <>
              <div
                className={`mb-2 cursor-pointer `}
                onClick={() => {
                  downloadSound();
                }}
              >
                <img
                  src={`${toAbsoluteUrl(`/media/sr/icons/download-blue.svg`)}`}
                  alt="download"
                  style={{
                    width: "35px",
                    height: "35px",
                  }}
                />
                <FormattedMessage id="download" defaultMessage="Download" />
              </div>
              <div
                onClick={() => {
                  handleEditSound();
                }}
                className={`mb-2 cursor-pointer `}
              >
                <img
                  src={`${toAbsoluteUrl(`/media/sr/icons/edit-pencil.svg`)}`}
                  alt="Edit"
                  style={{
                    width: "35px",
                    height: "35px",
                  }}
                />
                <FormattedMessage id="edit" defaultMessage="Edit" />
              </div>
            </>
          )}

          <div
            onClick={() => {
              handleCloseDeletePopup(true);
            }}
            className={`mb-2 cursor-pointer`}
          >
            <img
              src={`${toAbsoluteUrl(`/media/sr/icons/trash-blue.svg`)}`}
              alt="download"
              style={{
                width: "35px",
                height: "35px",
              }}
            />
            <FormattedMessage id="delete" defaultMessage="Delete" />
          </div>
        </div>
      </Popover>
    </>
  );
};

export default SoundActionsPopover;
